import { useContext } from 'react';
import { AuthContextInterface } from "./types";
import { AuthContext } from './authContext';

/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   canNavigateState,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAuthorizeUrl,
 *   getLogoutUrl,
 *   getAccessToken,
 *   userHasPrivilege,
 *  loginWithRedirect,
 *  loginWithPassword,
 *  logout,
 *  signup,
 *  signupConfirm,
 *  resetPassword,
 *  resetPasswordConfirm,
 * } = useAuth();
 * ```
 *
 * Use the `useAuth` hook in your components to access the auth state and methods.
 */
export const useAuth = (): AuthContextInterface => useContext(AuthContext);
